import {makeStyles} from "@mui/styles";
import {theme} from "../../../../config/design/theme";
const useStyles = makeStyles(() => {
    return {
        container: {
            maxHeight: '100vh',
            paddingLeft: 30,
            paddingTop: 30,
            paddingBottom: 30,
            width: '16rem',
        },
        drawerContainer: {
            zIndex: 999,
            height: '100vh !important',
            width: '23rem',
            padding: "100px 0 20px 40px",
            position: "sticky",
            top: 0,
            [theme.breakpoints.down('lg')]: {
                padding: 0,
                width: '17rem',
            },
        },
        sidebarBg: {
            overflow: 'hidden',
            borderRadius:30,
            padding:10,
            boxShadow: "0px 3px 30px 1px #0000001C",
            [theme.breakpoints.down('lg')]: {
                boxShadow: "none",
            },
            "& .menu-list":{
                maxHeight:"100%",
                overflowY:"auto"
            }
        },
        scrollAppSidebar: {
            marginTop:80,
            marginBottom: 25,
            backgroundColor: '#fff',
            height: 'calc(100vh - 100px)!important',

        },
        drawerScrollAppSidebar: {
            paddingBottom: 25,
            backgroundColor:"#fff",
            height: 'calc(100vh - 225px) !important' ,
        },

        sidebarModern: {
            height: '100%',
            width: '100%',
            color: 'white',
            overflow: 'hidden',
            borderRadius: 30,
        },
        sidebarStandard: {
            height: '100%',
            width: '100%',
            overflow: 'hidden',
        },
    };
});
export default useStyles;
